import React from "react";
import {
  Alert, Button, CircularProgress, List, ListItemButton, Stack, TextField, Typography, Chip, Paper,
} from "@mui/material";

export default function Step1SelectDbParent({
  dbParent,
  initialParentSearchQuery,
  initialParentSearchResults,
  initialParentSearchLoading,
  onQueryChange,
  onSelectDbParent,
  onClearDbParent,
}) {
  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Stack spacing={2}>
        <Typography variant="h6">Step 1: DB内からの親の選択</Typography>
        <Typography variant="body2">インポートの起点となる学名をデータベース内から検索・選択してください。</Typography>
        <TextField
          label="データベース内の親の学名を検索"
          value={initialParentSearchQuery}
          onChange={(e) => onQueryChange?.(e.target.value)}
          fullWidth
          autoFocus
          disabled={!!dbParent}
        />
        {dbParent ? (
          <Alert severity="success" action={<Button size="small" onClick={onClearDbParent}>変更</Button>}>
            選択中: <strong>{dbParent.name_spell_valid}</strong>
          </Alert>
        ) : initialParentSearchLoading ? (
          <Stack alignItems="center"><CircularProgress size={24} /></Stack>
        ) : (
          initialParentSearchResults.length > 0 && (
            <List sx={{ maxHeight: 300, overflow: 'auto', border: '1px solid', borderColor: 'divider', borderRadius: 1 }}>
              {initialParentSearchResults.map((name) => (
                <ListItemButton key={name.id} onClick={() => onSelectDbParent?.(name.id)} divider>
                  <Stack direction="row" spacing={2} alignItems="center" width="100%" py={0.5}>
                    <Typography variant="body1" sx={{ flex: '1 1 50%', fontWeight: 500 }}>{name.name_spell_valid}</Typography>
                    <Chip label={name.current_rank || 'N/A'} size="small" sx={{ flex: '0 0 auto' }} />
                    <Typography variant="body2" color="text.secondary" sx={{ flex: '1 1 40%', textAlign: 'right', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                      in {name.parent?.name_spell_valid || 'N/A'}
                    </Typography>
                  </Stack>
                </ListItemButton>
              ))}
            </List>
          )
        )}
      </Stack>
    </Paper>
  );
}
